import { render, staticRenderFns } from "./PolNoListByMomUpdDate.vue?vue&type=template&id=59275725&"
import script from "./PolNoListByMomUpdDate.vue?vue&type=script&lang=js&"
export * from "./PolNoListByMomUpdDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports